<div class='container otherNews'>
    <div class='row d-flex justify-content-center'>
        <h2 class="pb-5">News</h2>
    </div>

    <div class='row d-flex justify-content-center'>
        <nb-route-tabset [tabs]="tabs" class='routeTabsetOtherNews'></nb-route-tabset>
        <div class='col-xl-8 col-sm-12'>
            <div *ngIf="news.length == 0">
                <div class="row">
                    <div class="col">
                        <h3 class='text-center'>There are currently no news for this category!</h3>
                    </div>
                </div>
            </div>
            <div *ngFor="let singleNews of news">
                <nb-card>
                    <nb-card-body>
                        <div class="row">
                            <div class="col-sm">
                                <!-- IF there is no image do not show the div so that an empty container isnt shown. -->
                                <div *ngIf="singleNews['attributes'].imageLocation">
                                    <img class='img-responsive img-fluid img-featured pb-5'
                                        src="{{singleNews['attributes'].imageLocation}}">
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content-start">
                            <div class="col-sm">
                                <h3>{{singleNews['attributes'].title}}</h3>
                                <p>
                                    {{singleNews['attributes'].description}}
                                </p>
                            </div>
                        </div>
                        <nb-card-footer>
                            <div class="row pt-3">
                                <div class="col-sm">
                                    <div class="d-flex">
                                        <img class='img-responsive img-fluid lbLogo'
                                            src='../../../assets/images/Logo.png' alt='LitBitLogo'>
                                        <p class='ml-3'>
                                            Litbit<br>{{singleNews['attributes'].datePublished.split('-').join(' ')}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                        </nb-card-footer>
                        <!-- <div class="d-flex justify-content-center">
                            <a nbButton class='btn btnMiddle' status='primary'
                            href="{{'/news/single/' + singleNews['id']}}" status='primary'>Read
                            More</a>
                        </div> -->
                    </nb-card-body>
                    <div class="d-flex justify-content-center">
                            <a nbButton class='btn btnOtherNews' status='primary'
                                href="{{'/news/single/' + singleNews['id']}}" status='primary'>Read
                                More</a>
                    </div>
                </nb-card>
            </div>
        </div>
    </div>
</div>